import React from 'react';
import PropTypes from 'prop-types';

/**
 * @param {object} props - Props.
 * @returns {JSX.Element} Component.
 */
export const StatsSectionNavItems = ( { children } ) => {
    return (
        <>
            { React.Children.map( children, child => (
                <div className="stats-leaders-nav__item-wrapper">
                    { child }
                </div>
            ) ) }
        </>
    );
};

StatsSectionNavItems.defaultProps = {
    name: 'StatsSectionNavItems'
};

StatsSectionNavItems.propTypes = {
    children: PropTypes.any.isRequired
};